var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"task-info-root-container"},_vm._l((_vm.logList),function(item){return _c('task-log-item',{key:item.action_id,attrs:{"dataSource":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }